import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allForOrderReportOperatingFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/allForOrderReportOperatingFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/allForOrderReportOperatingFilter`;
